export default function FAQSection() {
  const faqs = [
    {
      q: '爱情岛论坛导航是什么？',
      a: '爱情岛论坛导航是一个第三方导航聚合网站，专门为用户收集和整理爱情岛论坛的所有可用入口链接，包括官方地址、备用线路、社区资源等。我们的目标是让用户一个书签就能找到所有入口，永不迷路。',
    },
    {
      q: '这里提供的链接是否安全可靠？',
      a: '我们提供的所有链接都经过人工验证，确保指向的是爱情岛论坛的官方或授权入口。我们会持续监控各链接的可用性状态，并及时更新。建议您通过本站导航访问论坛，避免误入仿冒网站。',
    },
    {
      q: '如果某个链接打不开怎么办？',
      a: '当某个链接无法访问时，您可以尝试我们提供的备用线路。我们有多个不同网络运营商优化的备用入口，通常情况下至少有一条线路是可用的。您也可以留意链接旁边的状态标识（绿色表示在线，黄色表示较慢，灰色表示暂不可用）。',
    },
    {
      q: '本站是否是爱情岛论坛的官方网站？',
      a: '不是。本站是独立的第三方导航网站，与爱情岛论坛官方无直接关联。我们的目标是帮助用户更方便地找到论坛入口，但本站不托管或管理论坛的任何内容。',
    },
    {
      q: '链接地址会定期更新吗？',
      a: '会的。我们团队会定期检查所有收录的链接状态，一旦发现地址变更或新增入口，会第一时间更新到导航页面。建议您收藏本站，以便随时获取最新地址。',
    },
    {
      q: '如何向本站推荐新的入口链接？',
      a: '如果您发现了新的可用入口链接，欢迎通过关于我们页面的联系方式向我们反馈。经过验证后，我们会将其添加到对应的分类中，帮助更多用户。',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            关于本站的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between p-5 cursor-pointer list-none">
                <h4 className="font-heading text-base text-foreground-900 pr-4">
                  {faq.q}
                </h4>
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-arrow-down-s-line text-lg group-open:rotate-180 transition-transform"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}